import { ValidationErrors } from '@angular/forms';

export const JAGA_RESET_PASSWORD_ERRORS = 'jaga-reset-password';

export interface JagaResetPasswordState {
  readonly [JAGA_RESET_PASSWORD_ERRORS]: ValidationErrors;
}
